import Icon from './Icon.jsx';

const TABS = [
  { id: 'home', label: 'Home', icon: 'cross' },
  { id: 'story', label: 'Story', icon: 'scroll' },
  { id: 'practice', label: 'Practice', icon: 'flame' },
  { id: 'flashcards', label: 'Verses', icon: 'book' },
  { id: 'people', label: 'People', icon: 'people' },
  { id: 'saved', label: 'Saved', icon: 'ribbon' },
  { id: 'chat', label: 'Ask', icon: 'dove' },
];

/**
 * One nav for both layouts: a bottom tab bar on phones (thumb reach, safe-area
 * aware) and a horizontal segmented control under the header on wider screens.
 * Layout is handled entirely in CSS so tab state has a single source.
 */
export default function NavBar({ current, onSelect, badges = {} }) {
  return (
    <nav className="nav" aria-label="Sections">
      {TABS.map((tab) => {
        const active = current === tab.id;
        const badge = badges[tab.id];
        return (
          <button
            key={tab.id}
            type="button"
            className={`nav__tab${active ? ' is-active' : ''}`}
            onClick={() => onSelect(tab.id)}
            aria-current={active ? 'page' : undefined}
          >
            <span className="nav__icon">
              <Icon name={tab.icon} size={20} />
            </span>
            <span className="nav__label">{tab.label}</span>
            {badge ? <span className="nav__badge">{badge}</span> : null}
          </button>
        );
      })}
    </nav>
  );
}

export { TABS };
